import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { baseURL, basicUnitType, basics } from "../../../basics";
import { uiActions } from "../../../store/Ui-slice";
import Loading from "../../Ui/Loading";
import LikeAndUnLikeButton from "../../Ui/LikeAndUnLikeButton";
import CheckStockAndChangeButton from "../../Ui/CheckStockAndChangeButton";
import GradeDescription from "../../Ui/GradeDescription";
import UnitTypeBox from "../../Ui/UnitTypeBox";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { MdVerified, MdSupportAgent } from "react-icons/md";
import { FaTruck } from "react-icons/fa";
import { IoLeafOutline } from "react-icons/io5";

const SinglePage = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const [dataProduct, setDataProduct] = useState<any>({});
  const [response, setResponse] = useState(false);
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    axios({
      method: "get",
      url: `${baseURL}api/Product/GetProduct?Id=${params.productId}`,
      responseType: "stream",
    })
      .then((res: any) => {
        setDataProduct(res.data);
        setResponse(true);
      })
      .catch(() => {
        dispatch(
          uiActions.showNotification({
            status: "error",
            title: "خطا",
            message: "مشکل در دریافت اطلاعات، لطفا دوباره اقدام کنید",
          }),
        );
      });
  }, [dispatch, params.productId]);

  useEffect(() => {
    setActiveImage(0);
  }, [dataProduct.id]);

  if (!response) {
    return (
      <div className="my-24 mx-auto">
        <Loading />
      </div>
    );
  }

  const images: string[] = dataProduct.images?.length
    ? dataProduct.images.map((image: any) => image.imageUrl)
    : dataProduct.imageUrl
      ? [dataProduct.imageUrl]
      : [];

  const descriptionLines: string[] = [
    ...(dataProduct.description
      ? dataProduct.description.split("\n").filter(Boolean)
      : []),
  ];

  const hasDiscount = dataProduct.discountedPrice !== dataProduct.price;
  const discountedPricePercent = dataProduct.price
    ? Math.floor(
        ((dataProduct.price - dataProduct.discountedPrice) /
          dataProduct.price) *
          100,
      )
    : 0;

  const showPreviousImage = () =>
    setActiveImage((current) =>
      current === 0 ? images.length - 1 : current - 1,
    );
  const showNextImage = () =>
    setActiveImage((current) =>
      current === images.length - 1 ? 0 : current + 1,
    );

  return (
    <div className="mx-auto mb-24 mt-12 sm:mt-24 max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="sm:grid sm:grid-cols-2 sm:gap-10 sm:items-start">
        {/* Gallery */}
        <div className="sm:order-2">
          <div className="relative flex items-center justify-center rounded-2xl border border-slate-100 bg-white p-6 sm:p-10 shadow-sm">
            <LikeAndUnLikeButton item={dataProduct} />
            {images.length > 0 && (
              <img
                src={`${baseURL}${images[activeImage]}`}
                className="h-52 sm:h-96 object-contain"
                alt={dataProduct.title}
              />
            )}
          </div>

          {images.length > 1 && (
            <div className="mt-3 flex justify-center gap-1.5 sm:hidden">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveImage(index)}
                  aria-label={`تصویر ${index + 1}`}
                  className={`h-1.5 rounded-full transition-all ${
                    index === activeImage
                      ? "w-4 bg-orange-500"
                      : "w-1.5 bg-slate-200"
                  }`}
                />
              ))}
            </div>
          )}

          {images.length > 1 && (
            <div className="mt-4 hidden sm:flex items-center gap-2">
              <button
                onClick={showPreviousImage}
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200 text-slate-500 hover:bg-slate-50 transition"
              >
                <IoIosArrowBack className="w-4 h-4" />
              </button>
              <div className="flex flex-1 gap-2 overflow-x-auto">
                {images.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveImage(index)}
                    className={`flex h-16 w-16 shrink-0 items-center justify-center rounded-lg border-2 p-1 transition ${
                      index === activeImage
                        ? "border-orange-500"
                        : "border-slate-100 hover:border-slate-200"
                    }`}
                  >
                    <img
                      src={`${baseURL}${image}`}
                      className="h-full w-full object-contain"
                      alt=""
                    />
                  </button>
                ))}
              </div>
              <button
                onClick={showNextImage}
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200 text-slate-500 hover:bg-slate-50 transition"
              >
                <IoIosArrowForward className="w-4 h-4" />
              </button>
            </div>
          )}
        </div>

        {/* Info */}
        <div className="mt-5 sm:mt-0 sm:order-1">
          <div className="hidden sm:flex justify-end">
            <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">
              تازه و با کیفیت
            </span>
          </div>

          <h1 className="text-xl sm:text-3xl font-extrabold text-gray-900">
            {dataProduct.title}
          </h1>

          <div className="mt-2 flex flex-wrap items-center gap-2">
            <GradeDescription
              grade={dataProduct.grade}
              color="black"
              align="right"
            />
            <UnitTypeBox
              unit={dataProduct.unit}
              unitType={dataProduct.unitType}
            />
            {dataProduct.unitType === 1 && (
              <div className="max-w-max rounded bg-orange-200 px-1.5 py-0.5 text-xs text-orange-800">
                ±50{basicUnitType[2]}
              </div>
            )}
            {dataProduct.unitType === 2 && (
              <div className="max-w-max rounded bg-orange-200 px-1.5 py-0.5 text-xs text-orange-800">
                ±5{basicUnitType[2]}
              </div>
            )}
            {dataProduct.gradeDescription && (
              <div className="max-w-max rounded bg-blue-300 px-1.5 py-0.5 text-xs text-blue-800">
                {dataProduct.gradeDescription}
              </div>
            )}
          </div>

          <div className="mt-4 flex w-fit items-center gap-3 rounded-xl border border-orange-100 bg-orange-50 px-4 py-3">
            {hasDiscount && (
              <span className="shrink-0 rounded-lg bg-orange-100 px-2 py-1 text-xs font-bold text-orange-700">
                {`${discountedPricePercent}% تخفیف`}
              </span>
            )}
            <div className="flex flex-col items-start">
              <div className="flex items-baseline gap-1">
                <span className="text-xl sm:text-2xl font-extrabold text-orange-600">
                  {(hasDiscount
                    ? dataProduct.discountedPrice
                    : dataProduct.price
                  )?.toLocaleString()}
                </span>
                <span className="text-xs sm:text-sm font-medium text-orange-600">
                  {basics.priceName}
                </span>
              </div>
              {hasDiscount && (
                <div className="flex items-baseline gap-1 text-xs text-gray-400 line-through sm:text-sm">
                  <span>{dataProduct.price?.toLocaleString()}</span>
                  <span>{basics.priceName}</span>
                </div>
              )}
            </div>
          </div>

          {descriptionLines.length > 0 && (
            <ul className="mt-4 list-disc space-y-1.5 pr-5 text-sm text-gray-600">
              {descriptionLines.map((line, index) => (
                <li key={index}>{line}</li>
              ))}
            </ul>
          )}

          <div className="mt-4 flex items-center justify-between gap-3 rounded-xl border border-emerald-100 bg-emerald-50 px-4 py-3">
            <div>
              <p className="text-sm font-bold text-gray-900">
                محصول سالم، تازه و با کیفیت
              </p>
              <p className="mt-0.5 text-xs text-emerald-700">
                ما به سلامت شما و محیط زیست اهمیت می‌دهیم.
              </p>
            </div>
            <MdVerified className="h-8 w-8 shrink-0 text-emerald-500" />
          </div>

          <div className="mt-6">
            <p className="mb-1.5 hidden text-sm font-bold text-gray-700 sm:block">
              تعداد
            </p>
            <CheckStockAndChangeButton
              items={dataProduct}
              large
              showLabel
              parentStyles="w-full sm:w-fit"
              childStyles="bg-orange-500 hover:bg-orange-600 shadow-sm"
            />
          </div>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-3 gap-2 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:mt-10 sm:gap-4 sm:p-6">
        <div className="flex flex-col items-center gap-1.5 text-center">
          <FaTruck className="h-6 w-6 text-emerald-600 sm:h-7 sm:w-7" />
          <p className="text-xs font-bold text-gray-900 sm:text-sm">
            ارسال سریع
          </p>
          <p className="text-[11px] text-gray-500 sm:text-xs">
            ارسال در کمتر از ۲۴ ساعت
          </p>
        </div>
        <div className="flex flex-col items-center gap-1.5 border-x border-slate-100 text-center">
          <IoLeafOutline className="h-6 w-6 text-emerald-600 sm:h-7 sm:w-7" />
          <p className="text-xs font-bold text-gray-900 sm:text-sm">
            محصول تازه
          </p>
          <p className="text-[11px] text-gray-500 sm:text-xs">
            ضمانت تازگی محصول
          </p>
        </div>
        <div className="flex flex-col items-center gap-1.5 text-center">
          <MdSupportAgent className="h-6 w-6 text-emerald-600 sm:h-7 sm:w-7" />
          <p className="text-xs font-bold text-gray-900 sm:text-sm">
            پشتیبانی ۲۴/۷
          </p>
          <p className="text-[11px] text-gray-500 sm:text-xs">
            پشتیبانی در تمام روزها
          </p>
        </div>
      </div>
    </div>
  );
};

export default SinglePage;
